<template>
  <transition-group class="accessory-list" name="list-complete" tag="div">
    <div
      v-for="category in list"
      :key="category.id"
      :ref="'cat' + category.id"
      class="accessory-category list-complete-item"
    >
      <div class="category-label">
        <span>{{ category.title }}</span>
        <div class="actions">
          <router-link
            :to="{ name: 'accessory-category-item', params: { id: category.id }}"
            class="action small-text"
          >Редактировать</router-link>
          <router-link
            :to="{ name: 'accessories-new', params: { id: category.id }}"
            title="Добавить аксессуар"
            class="action"
          >+</router-link>
        </div>
      </div>
      <div v-if="category.items.length">
        <accessory-list-item
          v-for="item in category.items"
          :key="item.id"
          :item="item"
          class="accessory"
        />
      </div>
      <div v-else>
        <p class="no-result">Нет результатов</p>
      </div>
    </div>
  </transition-group>
</template>

<script>
import AccessoryListItem from './AccessoryListItem';

export default {
  name: 'accessory-list',

  components: {
    AccessoryListItem,
  },

  props: {
    list: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.accessory-list {
  display: flex;
  flex-direction: column;

  .accessory-category {
    > * {
      margin: 20px 10px;
    }
  }

  .category-label {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    font-size: 22px;
    padding-bottom: 4px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.25);
  }

  .no-result {
    background: #ddd;
    padding: 4px;
  }

  .actions {
    display: flex;

    .action {
      margin-left: 4px;
      padding: 0 8px;
      background: #ddd;
      text-decoration: none;

      &:hover {
        background: #ccc;
        cursor: pointer;
      }

      &.small-text {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
  }
}
</style>

